module.exports = __webpack_public_path__ + "img/van-dark-grey.114ab38d.svg";